export default "__VITE_ASSET__XCpZRhwl__"